import { render, staticRenderFns } from "./NewComponent.vue?vue&type=template&id=6ca31c06&"
import script from "./NewComponent.vue?vue&type=script&lang=js&"
export * from "./NewComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports